module.exports = __webpack_public_path__ + "static/image-05@2x-fb789c422bf8599690e3f133e8550991.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/yieldr/image-05@2x.jpg
// module id = 431
// module chunks = 3627797113349 20562973939449 33019919093843